import { Box, GridLayout } from '@wishket/design-system';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import SectionTitle from './SectionTitle';
import CardCarousel from './CardCarousel';
import { CardCarouselPrevNextButtons } from './CardCarouselPrevNextButtons';
import { CarouselProvider } from './CarouselProvider';
import { MostHighlightedStatementProps } from './types';
import MostHighlightedStatementSkeleton from './MostHighlightedStatementSkeleton';

const MostHighlightedStatement = ({
  mostHighlightedTextsPromise,
}: MostHighlightedStatementProps) => {
  return (
    <CarouselProvider>
      <Box
        className="flex flex-col gap-6 tablet:gap-8"
        data-testid="landing-most-highlighted-statement"
      >
        <GridLayout>
          <Box className="flex justify-between grid-in-content">
            <SectionTitle />
            <CardCarouselPrevNextButtons />
          </Box>
        </GridLayout>
        <ErrorBoundary fallback={<MostHighlightedStatementSkeleton />}>
          <Suspense fallback={<MostHighlightedStatementSkeleton />}>
            <CardCarousel
              mostHighlightedTextsPromise={mostHighlightedTextsPromise}
            />
          </Suspense>
        </ErrorBoundary>
      </Box>
    </CarouselProvider>
  );
};

export default MostHighlightedStatement;
